import { ChangeEvent, FC } from 'react';
import { TimePickerProps } from '../types';

export const CalendarTimePicker: FC<TimePickerProps> = ({
	timeValue,
	onTimeChange,
}) => {
	const handleTimeChange = (event: ChangeEvent<HTMLInputElement>) => {
		onTimeChange(event.target.value);
	};

	return (
		<>
			{timeValue && (
				<label>
					Set the time:{' '}
					<input
						type="time"
						value={timeValue}
						onChange={handleTimeChange}
					/>
				</label>
			)}
		</>
	);
};
